import { render, staticRenderFns } from "./Fence.vue?vue&type=template&id=54934a2d&scoped=true"
import script from "./Fence.vue?vue&type=script&lang=ts"
export * from "./Fence.vue?vue&type=script&lang=ts"
import style0 from "./Fence.vue?vue&type=style&index=0&id=54934a2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54934a2d",
  null
  
)

export default component.exports